/* Bundle offer popup — réplique les offres Kaching depuis la page produit (JSON server-side)
 * et déclenche la vraie remise via les propriétés de ligne __kaching_bundles.
 * Aucune dépendance à l'UI Kaching, aucune remise à recréer. */
(function () {
  const CART_ADD_URL = (window.routes && window.routes.cart_add_url) || '/cart/add';
  const cache = new Map();

  function randId(n) {
    const a = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789';
    let s = '';
    for (let i = 0; i < (n || 4); i++) s += a[Math.floor(Math.random() * a.length)];
    return s;
  }

  function money(cents) {
    const v = (Number(cents) / 100).toFixed(2).replace('.', ',');
    return v + '€';
  }

  // Encode la propriété __kaching_bundles comme le fait l'app Kaching (_encodeBundlesProperty) :
  // base64 sur les thèmes Shrine PRO / Ascendify (leur système de morph/AJAX corrompt le JSON brut,
  // ce qui fait disparaître la ligne du panier), JSON brut ailleurs.
  function encodeBundlesProperty(obj) {
    const json = JSON.stringify(obj);
    try {
      const sn = ((window.Shopify && Shopify.theme && Shopify.theme.schema_name) || '').toLowerCase();
      if (sn.includes('shrine pro') || sn.includes('ascendify')) return btoa(json);
    } catch (e) { /* btoa indispo / chars non-latin1 : on retombe sur le JSON brut */ }
    return json;
  }

  function gidId(gid) {
    if (!gid) return null;
    const m = String(gid).match(/(\d+)\s*$/);
    return m ? Number(m[1]) : null;
  }

  function parseJSONScript(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  // Normalise les 2 sources (données carte Liquid OU script Kaching) vers une forme commune :
  // { id, title, options:[{name, values:[str]}], variants:[{id, options:[str], price, available}] }
  function normalizeProduct(raw) {
    if (!raw) return null;
    const variants = (raw.variants || []).map((v) => ({
      id: v.id,
      options: v.options || [],
      price: v.price,
      available: typeof v.available === 'boolean' ? v.available : !!v.availableForSale
    }));
    let options;
    if (raw.option_names) {
      options = raw.option_names.map((name, i) => ({
        name,
        values: [...new Set(variants.map((v) => v.options[i]).filter((x) => x != null))]
      }));
    } else if (raw.options) {
      options = raw.options.map((o) => ({
        name: o.name,
        values: (o.optionValues || []).map((ov) => ov.name)
      }));
    } else {
      options = [];
    }
    return { id: raw.id, title: raw.title, options, variants };
  }

  class BundleOfferPopup extends HTMLElement {
    constructor() {
      super();
      this.cartType = this.dataset.cartType || 'drawer';
    }

    connectedCallback() {
      this.grid = this.querySelector('[data-bundle-grid]');
      this.popup = this.querySelector('[data-bundle-popup]');
      this.popupContent = this.querySelector('[data-bundle-popup-content]');

      if (this.popup) {
        // Clic en dehors de la carte (sur le backdrop du <dialog>) -> fermeture.
        this.popup.addEventListener('click', (e) => { if (e.target === this.popup) this.closePopup(); });
        // Réinitialise le scroll quand le dialog se ferme (ESC natif du <dialog> inclus).
        this.popup.addEventListener('close', () => { document.documentElement.style.overflow = ''; });
      }

      this.addEventListener('click', (e) => {
        const atc = e.target.closest('[data-bundle-atc]');
        if (atc) { e.preventDefault(); this.onAtc(atc); return; }
        const bubble = e.target.closest('.bundle-bubble');
        if (bubble) { this.onFilter(bubble); return; }
        if (e.target.closest('[data-bundle-popup-close]')) { this.closePopup(); }
      });
      document.addEventListener('keyup', (e) => { if (e.key === 'Escape') this.closePopup(); });

      // Filtre initial (système d'onglets). Dans l'éditeur de thème, on affiche TOUTES les catégories
      // pour qu'une catégorie qu'on vient d'ajouter soit immédiatement visible (sinon le filtre la masque).
      const inEditor = window.Shopify && window.Shopify.designMode;
      const active = this.querySelector('.bundle-bubble.is-active');
      if (inEditor) {
        this.showAllGroups();
        // Sélectionner une catégorie dans l'éditeur l'isole ; la désélectionner réaffiche tout.
        this.addEventListener('shopify:block:select', (e) => {
          const group = e.target.closest && e.target.closest('[data-cat-group]');
          const bubble = e.target.closest && e.target.closest('.bundle-bubble');
          if (group) this.filterToGroup(group.dataset.catGroup);
          else if (bubble) this.filterToGroup(bubble.dataset.filter);
        });
        this.addEventListener('shopify:block:deselect', () => this.showAllGroups());
      } else if (active) {
        this.onFilter(active);
      }
    }

    showAllGroups() {
      this.querySelectorAll('[data-cat-group]').forEach((g) => { g.hidden = false; });
    }

    filterToGroup(key) {
      this.querySelectorAll('[data-cat-group]').forEach((g) => { g.hidden = g.dataset.catGroup !== key; });
    }

    /* ---------- Filtre bulles ---------- */
    onFilter(bubble) {
      const filter = bubble.dataset.filter;
      this.querySelectorAll('.bundle-bubble').forEach((b) => {
        const on = b === bubble;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });

      // « Tous » (*) affiche tous les groupes ; une bulle catégorie n'affiche que son groupe
      this.querySelectorAll('[data-cat-group]').forEach((g) => {
        g.hidden = !(filter === '*' || g.dataset.catGroup === filter);
      });
    }

    /* ---------- Données produit ---------- */
    cardData(productId) {
      const el = this.querySelector(`.bundle-card-data[data-product-id="${productId}"]`);
      return parseJSONScript(el);
    }

    async getProductData(url, productId) {
      if (cache.has(productId)) return cache.get(productId);
      const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const deal = parseJSONScript(
        doc.querySelector(`script.kaching-bundles-deal-block-settings[data-product-id="${productId}"]`)
      );
      const productsById = {};
      doc.querySelectorAll('script.kaching-bundles-product').forEach((s) => {
        const d = parseJSONScript(s);
        if (d && d.id) productsById[d.id] = d;
      });
      const data = { deal, productsById };
      cache.set(productId, data);
      return data;
    }

    /* ---------- Clic Ajouter au panier ---------- */
    async onAtc(btn) {
      if (btn.dataset.loading === 'true') return;
      this.setLoading(btn, true);
      const productId = btn.dataset.productId;
      const url = btn.dataset.productUrl;
      try {
        const data = await this.getProductData(url, productId);
        const bars = (data.deal && Array.isArray(data.deal.dealBars)) ? data.deal.dealBars : [];
        if (bars.length) {
          this.openOfferPopup(data, btn);
        } else if (btn.dataset.hasVariants === 'true') {
          this.openVariantPopup(btn);
        } else {
          await this.addToCart([{ id: Number(btn.dataset.variantId), quantity: 1 }]);
        }
      } catch (err) {
        console.error('[bundle] erreur chargement offres', err);
        // repli : ajout direct de la variante par défaut
        if (btn.dataset.variantId) await this.addToCart([{ id: Number(btn.dataset.variantId), quantity: 1 }]);
      } finally {
        this.setLoading(btn, false);
      }
    }

    setLoading(btn, on) {
      btn.dataset.loading = on ? 'true' : 'false';
      btn.classList.toggle('is-loading', on);
      const sp = btn.querySelector('.bundle-card__atc-spinner');
      if (sp) sp.hidden = !on;
    }

    /* ---------- Popup OFFRES ---------- */
    openOfferPopup(data, btn) {
      const deal = data.deal;
      const product = normalizeProduct(data.productsById[btn.dataset.productId] || this.cardData(btn.dataset.productId));
      const bars = deal.dealBars;
      this._ctx = { data, deal, product, btn };

      const cards = bars.map((bar, i) => {
        const totalQty = this.barQty(bar);
        const unit = this.unitPrice(product);
        const compare = unit * totalQty;
        const current = this.barTotal(bar, product);
        const selected = bar.id === deal.preselectedDealBarId ? ' is-selected' : '';
        return `
          <button type="button" class="bundle-offer${selected}" data-bar-index="${i}">
            ${bar.badgeText ? `<span class="bundle-offer__badge">${bar.badgeText}</span>` : ''}
            <span class="bundle-offer__title">${bar.title || ''}</span>
            ${bar.label ? `<span class="bundle-offer__save">${bar.label}</span>` : ''}
            <span class="bundle-offer__prices">
              ${compare > current ? `<s>${money(compare)}</s>` : ''}
              <strong>${money(current)}</strong>
            </span>
          </button>`;
      }).join('');

      this.popupContent.innerHTML = `
        <p class="bundle-popup__sub"></p>
        <div class="bundle-offer-list">${cards}</div>
        <div class="bundle-slots" data-slots></div>
        <button type="button" class="bundle-popup__add" data-add>Ajouter au panier</button>
      `;
      const sub = this.popupContent.querySelector('.bundle-popup__sub');
      if (sub) sub.textContent = this.dataset.packHeading || 'Choisis ton pack :';

      this.popupContent.querySelectorAll('.bundle-offer').forEach((b) => {
        b.addEventListener('click', () => {
          this.popupContent.querySelectorAll('.bundle-offer').forEach((x) => x.classList.remove('is-selected'));
          b.classList.add('is-selected');
          this.renderSlots(bars[Number(b.dataset.barIndex)], product);
        });
      });
      this.popupContent.querySelector('[data-add]').addEventListener('click', () => this.confirmOffer());

      const preIndex = Math.max(0, bars.findIndex((x) => x.id === deal.preselectedDealBarId));
      this.renderSlots(bars[preIndex], product);
      this.openPopup();
    }

    barQty(bar) {
      if (bar.dealBarType === 'bxgy') return (bar.buyQuantity || 0) + (bar.getQuantity || 0);
      return bar.quantity || 1;
    }

    unitPrice(product) {
      const v = (product && product.variants && product.variants.find((x) => x.available)) || (product && product.variants && product.variants[0]);
      return v ? v.price : 0;
    }

    // Prix total affiché du pack (le vrai prix est garanti par la Function Kaching côté serveur).
    // Schéma Kaching : discountType peut valoir 'specific' (discountValue = PRIX TOTAL FIXE en €),
    // 'percentage' (% de remise) ou 'fixed'/'amount' (montant € retiré du total). discountValue est
    // exprimé en unités monétaires (euros), pas en centimes.
    barTotal(bar, product) {
      const unit = this.unitPrice(product);
      const totalQty = this.barQty(bar);

      if (bar.dealBarType === 'bxgy') {
        // bxgy = portion "buy" + portion "get", chacune avec son propre type de remise.
        // 'specific' = prix fixe (€) pour la portion ; 'percentage' = % ; 'fixed'/'amount' = montant (€) retiré.
        const portion = (qty, type, val) => {
          if (type === 'specific') return Number(val || 0) * 100;
          let p = unit * (qty || 0);
          if (type === 'percentage') p = p * (1 - Number(val || 0) / 100);
          else if (type === 'fixed' || type === 'amount') p = p - Number(val || 0) * 100;
          return Math.max(0, p);
        };
        const buy = portion(bar.buyQuantity, bar.buyDiscountType, bar.buyDiscountValue);
        const get = portion(bar.getQuantity, bar.getDiscountType, bar.getDiscountValue);
        return Math.round(buy + get);
      }

      // quantity-break
      const dv = Number(bar.discountValue || 0);
      if (bar.discountType === 'specific') {
        // discountValue = prix total fixe de l'offre (ex: 24.99 -> 2499 centimes pour qté 3)
        return Math.round(dv * 100);
      }
      let total = unit * totalQty;
      if (bar.discountType === 'percentage') {
        total = total * (1 - dv / 100);
      } else if (bar.discountType === 'fixed' || bar.discountType === 'amount') {
        total = total - dv * 100;
      }
      return Math.round(Math.max(0, total));
    }

    renderSlots(bar, product) {
      this._ctx.bar = bar;
      const slotsEl = this.popupContent.querySelector('[data-slots]');
      const qty = this.barQty(bar);
      const opts = (product && product.options) || [];
      const realOptions = opts.filter((o) => !(o.values && o.values.length === 1 && o.values[0] === 'Default Title'));

      if (!realOptions.length) { slotsEl.innerHTML = ''; this._ctx.slotSelectors = []; return; }

      let html = `<p class="bundle-slots__label">${realOptions.map((o) => o.name).join(' / ')}</p>`;
      for (let i = 0; i < qty; i++) {
        html += `<div class="bundle-slot"><span class="bundle-slot__num">#${i + 1}</span>`;
        realOptions.forEach((o, oi) => {
          html += `<select class="bundle-slot__select" data-slot="${i}" data-opt="${oi}">` +
            (o.values || []).map((v) => `<option value="${v}">${v}</option>`).join('') +
            `</select>`;
        });
        html += `</div>`;
      }
      slotsEl.innerHTML = html;
      this._ctx.realOptions = realOptions;
    }

    findVariant(product, optionValues) {
      return (product.variants || []).find((v) => {
        return optionValues.every((val, idx) => v.options[idx] === val);
      });
    }

    confirmOffer() {
      const { deal, product, bar } = this._ctx;
      const groupId = randId(4);
      const items = [];
      const qty = this.barQty(bar);
      const realOptions = this._ctx.realOptions || [];

      // Articles payants (main:true)
      for (let i = 0; i < qty; i++) {
        let variantId;
        if (realOptions.length) {
          const vals = realOptions.map((o, oi) => {
            const sel = this.popupContent.querySelector(`select[data-slot="${i}"][data-opt="${oi}"]`);
            return sel ? sel.value : (o.values && o.values[0]);
          });
          const v = this.findVariant(product, vals);
          variantId = v ? v.id : (product.variants[0] && product.variants[0].id);
        } else {
          variantId = product.variants[0] && product.variants[0].id;
        }
        items.push({
          id: Number(variantId),
          quantity: 1,
          properties: { __kaching_bundles: encodeBundlesProperty({ deal: deal.nanoId, main: true, id: groupId, bid: bar.id }) }
        });
      }

      // Cadeaux (freeGifts avec productGID -> 1ère variante dispo du produit cadeau)
      (bar.freeGifts || []).forEach((g) => {
        if (g.giftType !== 'product' || !g.productGID) return;
        const gpId = gidId(g.productGID);
        const gProd = normalizeProduct(this._ctx.data.productsById[gpId]);
        let gVariantId = null;
        if (g.variantGIDs && g.variantGIDs.length) gVariantId = gidId(g.variantGIDs[0]);
        else if (gProd) { const gv = (gProd.variants || []).find((x) => x.available) || gProd.variants[0]; gVariantId = gv && gv.id; }
        if (!gVariantId) return;
        items.push({
          id: Number(gVariantId),
          quantity: g.quantity || 1,
          properties: { __kaching_bundles: encodeBundlesProperty({ id: groupId, deal: deal.nanoId, gift: g.id }) }
        });
      });

      const addBtn = this.popupContent.querySelector('[data-add]');
      if (addBtn) { addBtn.disabled = true; addBtn.classList.add('is-loading'); }
      this.addToCart(items).then(() => this.closePopup()).finally(() => {
        if (addBtn) { addBtn.disabled = false; addBtn.classList.remove('is-loading'); }
      });
    }

    /* ---------- Popup VARIANTES (produit sans offre) ---------- */
    openVariantPopup(btn) {
      const product = normalizeProduct(this.cardData(btn.dataset.productId));
      if (!product) { return this.addToCart([{ id: Number(btn.dataset.variantId), quantity: 1 }]); }
      const opts = (product.options || []).filter((o) => !(o.values && o.values.length === 1 && o.values[0] === 'Default Title'));
      this._ctx = { product, variantOnly: true };

      let selectsHtml = opts.map((o, oi) =>
        `<label class="bundle-slot__label">${o.name}</label>
         <select class="bundle-slot__select" data-opt="${oi}">` +
        (o.values || []).map((v) => `<option value="${v}">${v}</option>`).join('') + `</select>`
      ).join('');

      this.popupContent.innerHTML = `
        <h2 class="bundle-popup__heading">${product.title || ''}</h2>
        <div class="bundle-slots">${selectsHtml}</div>
        <button type="button" class="bundle-popup__add" data-add>Ajouter au panier</button>`;

      this.popupContent.querySelector('[data-add]').addEventListener('click', () => {
        const vals = opts.map((o, oi) => this.popupContent.querySelector(`select[data-opt="${oi}"]`).value);
        const v = this.findVariant(product, vals) || product.variants[0];
        this.addToCart([{ id: Number(v.id), quantity: 1 }]).then(() => this.closePopup());
      });
      this.openPopup();
    }

    /* ---------- Ajout panier + ouverture drawer/notif ---------- */
    async addToCart(items) {
      const sections = this.cartType === 'notification'
        ? ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble']
        : null;
      const body = { items };
      if (sections) { body.sections = sections; body.sections_url = window.location.pathname; }

      const res = await fetch(`${CART_ADD_URL}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      });
      const json = await res.json();
      if (json.status) { console.error('[bundle] /cart/add', json); throw new Error(json.description || 'cart add error'); }

      document.dispatchEvent(new CustomEvent('cart:refresh'));

      if (this.cartType === 'notification') {
        const cn = document.querySelector('cart-notification');
        if (cn && json.sections) { try { cn.renderContents(json); } catch (e) { this.openCartIcon(); } }
        else this.openCartIcon();
      } else {
        // Drawer : passe par le contrôleur du thème qui re-render les sections
        // ET bascule la classe `is-empty` (sinon le 1er ajout reste invisible sans rechargement).
        const ctrl = window.CartDrawerController;
        if (ctrl && typeof ctrl.update === 'function') {
          try { await ctrl.update(); ctrl.open(); return json; } catch (e) { /* repli ci-dessous */ }
        }
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') { drawer.classList.remove('is-empty'); drawer.open(); }
        else this.openCartIcon();
      }
      return json;
    }

    openCartIcon() {
      const icon = document.getElementById('cart-icon-bubble');
      if (icon) icon.click();
    }

    /* ---------- Popup show/hide (<dialog> natif, top layer) ---------- */
    openPopup() {
      if (!this.popup) return;
      if (typeof this.popup.showModal === 'function') {
        if (!this.popup.open) this.popup.showModal();
      } else {
        // Repli navigateurs sans <dialog> : affichage simple
        this.popup.setAttribute('open', '');
      }
      document.documentElement.style.overflow = 'hidden';
    }

    closePopup() {
      if (!this.popup) return;
      if (typeof this.popup.close === 'function') {
        if (this.popup.open) this.popup.close();
      } else {
        this.popup.removeAttribute('open');
      }
      document.documentElement.style.overflow = '';
    }
  }

  customElements.define('bundle-offer-popup', BundleOfferPopup);
})();
